import TableSearch from './table-search.vue'

export default TableSearch
